import app from "flarum/forum/app";
import Notification from "flarum/forum/components/Notification";
/**
 * Notification card shown when an admin verifies the user's account.
 * Clicking the card takes the user to their own profile, where they can
 * see the badge in the hero.
 */
export default class UserVerifiedNotification extends Notification {
  icon() {
    return "fas fa-certificate";
  }
  href() {
    // Notification.subject() returns a generic Model — for user-verified we
    // know it's the verified User and route.user() needs that concrete type.
    const subject = this.attrs.notification.subject();
    return subject ? app.route.user(subject) : "";
  }
  content() {
    return app.translator.trans("ziiven-verified.forum.notifications.user_verified_text");
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('ziiven-verified', 'forum/components/UserVerifiedNotification', UserVerifiedNotification);